// Wraps a Vue reference to a Boostrap modal object to provide show/hide Promises
const modalMixin = {
    methods: {
        $modal(ref) {
            // Don't re-wrap
            if(! ref._show) {
                ref._show = ref.show;
                ref._hide = ref.hide;
                ref.show = function() {
                    let promise = new Promise((resolve) => {
                    this.$el.addEventListener(
                            'shown.bs.modal',
                            resolve
                        );
                    });
                    this._show();
                    return promise;
                };
                ref.hide = function() {
                    let promise = new Promise((resolve) => {
                    this.$el.addEventListener(
                            'hidden.bs.modal',
                            resolve
                        );
                    });
                    this._hide();
                    return promise;
                };
            }

            return ref;
        }
    }
}

export default modalMixin;